import React, { useEffect, useMemo, useState } from "react";
import { Modal, Checkbox, Input, Typography, Select, Table } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import PrimaryButton from "../Forms/PrimaryButton";
import DataTable from "../Tables/Datatable";
import SearchInput from "../Forms/SearchInput";
import Filters from "../Filters";

const { Title, Text } = Typography;
const { Search } = Input;

export default function ApplyProductModal({
  open,
  onClose,
  handleSubmit,
  title = "Apply Products",
  buttonTitle = "Proceed",
  loading,
  width = 420,
  productData = [],
  selectedproduct = [],
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);

  const { appliedFilters, ModalUI, FilterButton, resetFilters } = Filters({
    filters: [
      {
        type: "select",
        key: "clienttype",
        label: "Category",
        options: productData
          .map((item) => item?.clienttype)
          .filter((value, index, self) => value && self.indexOf(value) === index)
          .map((cat) => ({ label: cat, value: cat })),

        inputProps: {
          placeholder: "Select Category",
        },
      },
      {
        type: "select",
        key: "fabric_type",
        label: "Fabric Type",
        options: productData
          .map((item) => item?.fabric_type)
          .filter((value, index, self) => value && self.indexOf(value) === index)
          .map((cat) => ({ label: cat, value: cat })),

        inputProps: {
          placeholder: "Select Fabric Type",
        },
      },
    ],
  });

  useEffect(() => {
    if (open) {
      setSelectedItems(selectedproduct.map((item) => item.sort_no));
      setSearch("");
    }
  }, [open]);

  const filteredProducts = useMemo(() => {
    let data = [...productData];

    if (search) {
      const searchText = search.toLowerCase();

      data = data.filter(
        (item) =>
          item?.short_name?.toLowerCase().includes(searchText) ||
          item?.clienttype?.toLowerCase().includes(searchText) ||
          item?.fabric_type?.toLowerCase().includes(searchText),
      );
    }

    if (Object.keys(appliedFilters).length) {
      data = data.filter((item) => {
        return Object.entries(appliedFilters).every(([key, value]) => {
          return !value || item[key] === value;
        });
      });
    }

    return data;
  }, [productData, search, appliedFilters]);

  const toggleItem = (id) => {
    setSelectedItems((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  const selectAll = (e) => {
    e.stopPropagation();
    const val = e.target.checked;
    if (!val) {
      setSelectedItems(
        selectedItems.filter((i) => !filteredProducts.map((p) => p.sort_no).includes(i)),
      );
    } else {
      setSelectedItems([...new Set([...selectedItems, ...filteredProducts.map((i) => i.sort_no)])]);
    }
  };

  const onProceed = () => {
    setLoader(true);
    setTimeout(() => {
      handleSubmit(selectedItems);
      setLoader(false);
    }, 300);
  };

  const columns = [
    {
      title: () => <span className="text-gray-900 text-left font-normal">Products</span>,
      dataIndex: "short_name",
      ellipsis: true,
      render: (_, record) => (
        <div className="flex gap-2 items-center">
          <img
            src={record?.product?.product_pic_url}
            alt={record?.short_name}
            className="w-10 h-10 rounded object-cover"
          />

          <div>
            <div className="font-medium">{record?.short_name}</div>

            <div className="text-xs text-gray-500">
              {record?.clienttype} | {record?.fabric_type}
            </div>
          </div>
        </div>
      ),
    },

    {
      title: (
        <Checkbox
          checked={
            filteredProducts.length > 0 &&
            filteredProducts.every((p) => selectedItems.includes(p.sort_no))
          }
          onChange={selectAll}
        />
      ),
      width: 50,
      align: "center",
      render: (_, record) => (
        <Checkbox
          checked={selectedItems.includes(record.sort_no)}
          onChange={() => toggleItem(record.sort_no)}
        />
      ),
    },
  ];

  return (
    <>
      <ModalUI />
      <Modal
        open={open}
        footer={null}
        onCancel={() => {
          onClose?.();
          resetFilters();
        }}
        width={width}
        className="form-css-2"
      >
        <div className="flex justify-between items-center mb-3">
          <Title level={2} className="text-3xl font-semibold text-gray-800 font-abhaya m-0">
            {title}
          </Title>
        </div>

        <div className="flex gap-2 items-center mb-3">
          <SearchInput
            placeholder="Search for a product"
            onSearch={() => {}}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <FilterButton />
        </div>

        {/* <div className="flex justify-end mb-2">
        <Text
          className="text-red-500 cursor-pointer text-sm"
          onClick={selectAll}
        >
          {selectedItems.length === filteredProducts.length
            ? "Clear All"
            : "Select All"}
        </Text>
      </div> */}

        <DataTable
          rowKey="sort_no"
          columns={columns}
          dataSource={filteredProducts}
          pagination={false}
          Showpagination={false}
          customEmptySection={"Sorry, no products found"}
          rootClassName="transparent-table"
        />

        <div className="flex justify-center mt-4">
          <PrimaryButton
            text={buttonTitle}
            loading={loading || loader}
            disabled={!selectedItems.length}
            onClick={onProceed}
            className="w-[160px]"
          />
        </div>
      </Modal>
    </>
  );
}
